import { Link } from 'react-router-dom';

export interface SimulationLinksProps {
  primaryLink: string;
  primaryLinkChildren: React.ReactNode;
  secondaryLink: string;
  secondaryLinkChildren: React.ReactNode;
}

export const SimulationLinks = ({
  primaryLink,
  primaryLinkChildren,
  secondaryLink,
  secondaryLinkChildren
}: SimulationLinksProps) => {
  return (
    <div className="flex w-full items-center justify-center gap-4">
      <Link
        className="bg-soFresh-140 text-soClean-100 disabled:bg-soFresh-150 disabled:text-soClean-180 flex flex-row items-center justify-center rounded-md px-3 py-2 text-base font-medium disabled:cursor-not-allowed"
        to={primaryLink}
      >
        {primaryLinkChildren}
      </Link>
      <Link
        className="bg-stankonia-100 text-soClean-100 disabled:bg-stankonia-300 disabled:text-soClean-180 flex flex-row items-center justify-center rounded-md px-3 py-2 text-base font-medium disabled:cursor-not-allowed"
        to={secondaryLink}
      >
        {secondaryLinkChildren}
      </Link>
    </div>
  );
};
